import React, { useState } from "react";
import { createPortal } from "react-dom";
import { useSelector } from "react-redux";
import {
    formatPrice,
    getSessionStatus,
    getSessionDate,
} from "../../../helpers";
import { Link, useNavigate } from "react-router-dom";
import useTranslationHook from "../../hooks/useTranslationHook";
import RegisterInterestModal from "../../partials/property-details/right-panel/modals/RegisterInterestModal";
import VerifyAccountModal from "../../partials/property-details/right-panel/modals/VerifyAccountModal";
import { accountStatus } from "../../../utils/constants";

const LiveCard = ({ ele, syncData }) => {
    const isAuthenticated = useSelector((state) => state.auth?.isAuthenticated);
    const user = useSelector((state) => state.auth?.user);
    const navigate = useNavigate();
    const { t } = useTranslationHook();
    const lang = useSelector((state) => state.translation.lang);
    const [showRegisterInterestModal, setShowRegisterInterestModal] =
        useState(false);
    const [isRegisteredInterest, setIsRegisteredInterest] = useState(
        ele?.is_register_interest ?? false
    );
    const [accountVerifiedModal, setAccountVerifiedModal] = useState(false);

    const onClickBidRegistration = () => {
        if (!isAuthenticated) {
            navigate(
                `/sign-in?redirect=${encodeURIComponent(location.pathname)}`
            );
            return;
        } else {
            if (
                (user?.user_account_verification ||
                    user?.is_account_verified) !== accountStatus?.success
            ) {
                setAccountVerifiedModal(true);
                return;
            }
        }

        navigate("/bidder-registration", {
            state: {
                selectedSessionID: ele?.id,
                propertyId: ele?.lot_list?.[0]?.property_id,
                propertyName: ele?.name,
                lotID: ele?.lot_list?.[0]?.id,
                currentPathName: `${window.location.origin}/session-details/${ele?.id}`,
            },
        });
    };

    return (
        <>
            {/* ── New session card design (dynamic) ── */}
            <li>
                {(() => {
                    const { className: statusClass, label: statusLabel } =
                        getSessionStatus(ele?.status);
                    const isEnded = [8, 9, 16, 35, 38].includes(ele?.status);
                    const isUpcoming = ele?.status === 37;
                    const isRegistered = ele?.is_registered;
                    const isPaid = ele?.is_payment_completed;
                    const isRegistrationApproved = Boolean(
                        ele?.is_registration_approved
                    );
                    const { dateLabel, timeLabel } = getSessionDate(
                        ele?.start_date,
                        isEnded
                    );
                    return (
                        <>
                            <figure>
                                <Link to={`/session-details/${ele?.id}`}>
                                    <img
                                        className="slide-fixed"
                                        src="/img/trans-3x2.png"
                                        alt=""
                                    />
                                    <img
                                        className="slide-img"
                                        src={
                                            ele?.session_images?.[0]
                                                ?.bucket_name &&
                                            ele?.session_images?.[0]
                                                ?.doc_file_name
                                                ? `${process.env.REACT_APP_AZURE_BLOB_URL}${ele.session_images[0].bucket_name}/${ele.session_images[0].doc_file_name}`
                                                : "/img/slide-1.jpg"
                                        }
                                        alt=""
                                    />
                                </Link>
                                <div className="top">
                                    <span
                                        className={`status-info ${statusClass}`}
                                    >
                                        {statusClass === "live" && <em></em>}{" "}
                                        {statusLabel}
                                    </span>
                                    <span className="date">
                                        <img src="/img/calendar.svg" alt="" />
                                        <strong>{dateLabel}</strong>
                                        {timeLabel && ` • ${timeLabel}`}
                                    </span>
                                </div>
                            </figure>
                            <figcaption>
                                <h6 className="lots">
                                    {ele?.name}
                                    <span className="total">
                                        <img
                                            src="/img/totallot-icon.svg"
                                            alt=""
                                        />{" "}
                                        {ele?.no_lot} {t("Lots")}
                                    </span>
                                </h6>
                                <div className="price">
                                    <em className="dirham">D</em>{" "}
                                    {formatPrice(ele?.minimum_deposit, lang)}{" "}
                                    <span>{t("Min. Deposit")}</span>
                                </div>
                                <div className="name">
                                    <figure>
                                        <img
                                            className="slide-fixed"
                                            src="/img/cal-trans-today.png"
                                            alt=""
                                        />
                                        <img
                                            className="slide-img"
                                            src="/img/logo.svg"
                                            alt=""
                                        />
                                    </figure>
                                    <h6>
                                        {ele?.auctioneer_name}{" "}
                                        <span>• {t("Auctioneer")}</span>
                                    </h6>
                                </div>
                                <div className="btns">
                                    <button
                                        className="btn btn-white btn-sm width100"
                                        onClick={() =>
                                            navigate(
                                                `/session-details/${ele?.id}`
                                            )
                                        }
                                    >
                                        {t("More Details")}
                                    </button>
                                    {!isEnded &&
                                        (() => {
                                            const sessionState = {
                                                selectedSessionID: ele?.id,
                                            };
                                            const sessionDetailsUrl = `/session-details/${ele?.id}`;

                                            if (isUpcoming) {
                                                if (isRegisteredInterest) {
                                                    return (
                                                        <button
                                                            className="btn btn-primary btn-sm width100"
                                                            disabled
                                                        >
                                                            {t(
                                                                "Already Registered Interest"
                                                            )}
                                                        </button>
                                                    );
                                                }
                                                return (
                                                    <button
                                                        className="btn btn-primary btn-sm width100"
                                                        onClick={() =>
                                                            isAuthenticated
                                                                ? setShowRegisterInterestModal(
                                                                      true
                                                                  )
                                                                : navigate(
                                                                      `/sign-in?redirect=${encodeURIComponent(sessionDetailsUrl)}`
                                                                  )
                                                        }
                                                    >
                                                        {t("Register Interest")}
                                                    </button>
                                                );
                                            }

                                            if (ele?.status === 41) {
                                                if (
                                                    isRegistered &&
                                                    isPaid &&
                                                    !isRegistrationApproved
                                                ) {
                                                    return (
                                                        <button
                                                            className="btn btn-primary btn-sm width100"
                                                            disabled
                                                        >
                                                            {t(
                                                                "Approval Pending"
                                                            )}
                                                        </button>
                                                    );
                                                }
                                                if (
                                                    isRegistered &&
                                                    isPaid &&
                                                    isRegistrationApproved
                                                ) {
                                                    return (
                                                        <button
                                                            title={t(
                                                                "Bidder Registration Completed"
                                                            )}
                                                            className="btn btn-primary btn-sm width100 bidder-btn"
                                                            disabled
                                                        >
                                                            {t(
                                                                "Bidder Registration Completed"
                                                            )}
                                                        </button>
                                                    );
                                                }
                                                return (
                                                    <button
                                                        className="btn btn-primary btn-sm width100"
                                                        onClick={
                                                            onClickBidRegistration
                                                        }
                                                    >
                                                        {t("Register to Bid")}
                                                    </button>
                                                );
                                            }

                                            if (ele?.status === 1) {
                                                if (
                                                    isRegistered &&
                                                    isPaid &&
                                                    isRegistrationApproved
                                                ) {
                                                    return (
                                                        <button
                                                            className="btn btn-primary btn-sm width100"
                                                            onClick={() =>
                                                                navigate(
                                                                    "/live-auction-details",
                                                                    {
                                                                        state: sessionState,
                                                                    }
                                                                )
                                                            }
                                                        >
                                                            {t("Join Now")}
                                                        </button>
                                                    );
                                                }
                                                if (
                                                    isRegistered &&
                                                    isPaid &&
                                                    !isRegistrationApproved
                                                ) {
                                                    return (
                                                        <button
                                                            className="btn btn-primary btn-sm width100"
                                                            disabled
                                                        >
                                                            {t(
                                                                "Approval Pending"
                                                            )}
                                                        </button>
                                                    );
                                                }
                                                return (
                                                    <button
                                                        className="btn btn-primary btn-sm width100"
                                                        onClick={() =>
                                                            isAuthenticated
                                                                ? navigate(
                                                                      "/live-auction-details",
                                                                      {
                                                                          state: sessionState,
                                                                      }
                                                                  )
                                                                : navigate(
                                                                      `/sign-in?redirect=${encodeURIComponent("/live-auction-details")}&data=${encodeURIComponent(JSON.stringify(sessionState))}`
                                                                  )
                                                        }
                                                    >
                                                        {t("Watch Now")}
                                                    </button>
                                                );
                                            }

                                            return null;
                                        })()}
                                </div>
                            </figcaption>
                        </>
                    );
                })()}
            </li>
            {showRegisterInterestModal &&
                createPortal(
                    <RegisterInterestModal
                        show={showRegisterInterestModal}
                        onClose={() => setShowRegisterInterestModal(false)}
                        property={ele?.lot_list?.[0]?.property_id}
                        setIsRegisteredInterest={setIsRegisteredInterest}
                        rememberMeFlag={ele?.is_remember_interest ?? false}
                    />,
                    document.body
                )}
            <VerifyAccountModal
                show={accountVerifiedModal}
                onClose={() => setAccountVerifiedModal(false)}
            />
        </>
    );
};

export default LiveCard;
